import { useEffect, useState } from 'react'

export function useGeoCity(): string | null {
  const [geoCity, setGeoCity] = useState<string | null>(null)
  useEffect(() => {
    const match = document.cookie.match(/(?:^|;\s*)x-geo-city=([^;]*)/)
    setGeoCity(match ? decodeURIComponent(match[1]) : null)
  }, [])
  return geoCity
}
